module.exports = __webpack_public_path__ + "img/canda2.f2f01270.jpg";